module.exports = "/img/indexQrcode.c4f155d9.png";